import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { sharingApi } from '../../lib/api/sharingApi';
import { SharedChatItem } from './SharedChatItem';
export function SharedWithMeList({ onChatSelect }) {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const loadSharedChats = useCallback(async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const response = await sharingApi.getSharedWithMe(page, 20);
            setData(response);
        } catch (_err) {
            setError('Failed to load shared chats');
        } finally{
            setIsLoading(false);
        }
    }, [
        page
    ]);
    useEffect(()=>{
        loadSharedChats();
    }, [
        loadSharedChats
    ]);
    if (isLoading && !data) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex items-center justify-center py-8 text-muted-foreground",
            "data-testid": "shared-with-me-loading",
            children: "Loading shared chats..."
        });
    }
    if (error) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col items-center justify-center py-8 gap-3",
            "data-testid": "shared-with-me-error",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text-sm text-muted-foreground",
                    children: error
                }),
                /*#__PURE__*/ _jsx("button", {
                    onClick: loadSharedChats,
                    className: "px-3 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90",
                    children: "Retry"
                })
            ]
        });
    }
    if (!data || data.chats.length === 0) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col items-center justify-center py-8 text-center",
            "data-testid": "shared-with-me-empty",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text-sm text-muted-foreground",
                    children: "No chats have been shared with you yet."
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-xs text-muted-foreground mt-1",
                    children: "When someone shares a chat with you, it will appear here."
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "shared-with-me-list",
        children: [
            /*#__PURE__*/ _jsx("ul", {
                className: "border border-border rounded-md divide-y divide-border",
                children: data.chats.map((chat)=>/*#__PURE__*/ _jsx(SharedChatItem, {
                        chat: chat,
                        onClick: ()=>onChatSelect(chat.chatId)
                    }, chat.chatId))
            }),
            data.pagination.totalPages > 1 && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between mt-4 px-4 py-2 border border-border rounded-md",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        disabled: page === 1,
                        onClick: ()=>setPage((p)=>p - 1),
                        className: "px-3 py-1 text-sm bg-muted rounded disabled:opacity-50 hover:bg-muted/80",
                        children: "Previous"
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "text-sm text-muted-foreground",
                        children: [
                            "Page ",
                            data.pagination.page,
                            " of ",
                            data.pagination.totalPages
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        disabled: page >= data.pagination.totalPages,
                        onClick: ()=>setPage((p)=>p + 1),
                        className: "px-3 py-1 text-sm bg-muted rounded disabled:opacity-50 hover:bg-muted/80",
                        children: "Next"
                    })
                ]
            })
        ]
    });
}
